// src/components/PartnerLogin.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import bcrypt from 'bcryptjs';
import { useAuth } from '../context/AuthContext';
import './Login.css';

const PartnerLogin = () => {
  const [formData, setFormData] = useState({ name: '', password: '' });
  const navigate = useNavigate();
  const { loginPartner } = useAuth();
  const logoUrl = process.env.PUBLIC_URL + '/logo.jpeg';

  // Predefined name and hashed password (hashed '2000' password)
  const predefinedName = 'Partner';
  const hashedPassword = '$2a$10$Vp.j1VGgIMVuDc1Std3TKOINSLpyn5w9vD1HgML1jlCHiZJFb01vi'; // hashed '2000'

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Partner Login:', formData);

    // Check if the name matches
    if (formData.name === predefinedName) {
      // Compare the password with the hashed password
      bcrypt.compare(formData.password, hashedPassword, (err, result) => {
        if (result) {
          // Successful login - store user in context
          const partnerUser = { name: formData.name };
          loginPartner(partnerUser);

          navigate('/partner-dashboard'); // Redirect to dashboard
        } else {
          alert('Incorrect password');
        }
      });
    } else {
      alert('Incorrect name');
    }
  };

  return (
    <div className="login-page">
      <style>
        {`
          /* General Page Styling */
          body {
            font-family: 'Poppins', Arial, sans-serif;
            background: linear-gradient(135deg, #dfe9f3, #ffffff);
            margin: 0;
            padding: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100vh;
          }

          /* Login Page Container */
          .login-page {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height: 100vh;
          }

          /* Login Header */
          .login-header {
            text-align: center;
            margin-bottom: 30px;
            color: #333;
          }

          .login-logo {
            width: 80px;
            height: 80px;
            border-radius: 50%;
            object-fit: cover;
            margin-bottom: 15px;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
          }

          .login-title {
            font-size: 24px;
            font-weight: bold;
            margin: 0;
            color: #333;
            text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
          }

          /* Login Form Container */
          .login-form-container {
            width: 350px;
            padding: 25px;
            background: #fff;
            border-radius: 12px;
            box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.15);
            text-align: center;
            transition: transform 0.3s ease-in-out;
          }

          .login-form-container:hover {
            transform: scale(1.02);
          }

          h2 {
            font-size: 24px;
            color: #333;
            margin-bottom: 20px;
          }

          /* Input Fields */
          .login-form-container input {
            width: 100%;
            padding: 12px;
            margin: 10px 0;
            border-radius: 8px;
            border: 1px solid #ccc;
            font-size: 16px;
            transition: all 0.3s ease-in-out;
          }

          .login-form-container input:focus {
            outline: none;
            border-color: #007bff;
            box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
          }

          /* Login Button */
          .login-form-container button {
            width: 100%;
            padding: 12px;
            background: #007bff;
            color: white;
            font-weight: bold;
            border: none;
            border-radius: 8px;
            cursor: pointer;
            transition: background 0.3s, transform 0.2s;
            font-size: 16px;
          }

          .login-form-container button:hover {
            background: #0056b3;
            transform: scale(1.05);
          }

          /* Responsive Design */
          @media screen and (max-width: 480px) {
            .login-form-container {
              width: 90%;
              padding: 20px;
            }

            .login-form-container input {
              font-size: 14px;
            }

            .login-form-container button {
              font-size: 14px;
            }
          }
        `}
      </style>

      <div className="login-header">
        <img src={logoUrl} alt="Logo" className="login-logo" />
        <h1 className="login-title">SHREE DHANESHWARI FINANCE AND LEASING</h1>
      </div>
      <div className="login-form-container">
        <h2>Partner Login</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Name"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <input
            type="password"
            name="password"
            placeholder="Password"
            value={formData.password}
            onChange={handleChange}
            required
          />
          <button type="submit">Login</button>
        </form>
      </div>
    </div>
  );
};

export default PartnerLogin;
